import React, { useEffect } from 'react';
import { TileLayer, LayersControl } from 'react-leaflet';
const { BaseLayer } = LayersControl;

const MapLayers = props => {
  const { activeLayer, setActiveLayer } = props;

  useEffect(() => {
    const changeHandler = function(event) { setActiveLayer(this); };
    const [radioLight, radioSat] = document.querySelectorAll('input.leaflet-control-layers-selector');
    radioLight.addEventListener('change', changeHandler.bind(0));
    radioSat.addEventListener('change', changeHandler.bind(1));
    return () => {
      radioLight.removeEventListener('change', changeHandler.bind(0));
      radioSat.removeEventListener('change', changeHandler.bind(1));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LayersControl position="topright">
      <BaseLayer checked={activeLayer === 0} name="Carto.Light">
        <TileLayer
          url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
          attribution='&copy; &lt;a href="http://www.openstreetmap.org/copyright"&gt;OpenStreetMap&lt;/a&gt; contributors, &copy; &lt;a href="https://carto.com/attribution"&gt;CARTO&lt;/a&gt;'
        />
      </BaseLayer>
      <BaseLayer checked={activeLayer === 1} name="Satellite">
        <TileLayer maxNativeZoom={16} url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" />
      </BaseLayer>
    </LayersControl>
  );
};

export { MapLayers as default };
